import axios from "@/api/axios";

class AdminNotificationService {
  async getAll(params = {}) {
    return axios.get("/notifications", { params });
  }

  async getUnreadCount() {
    return axios.get("/notifications/unread-count");
  }

  async markAsRead(id) {
    return axios.post(`/notifications/${id}/read`);
  }

  async markAllAsRead() {
    return axios.post("/notifications/read-all");
  }

  async sendTestNotification() {
    return axios.get("/dev/test-notification");
  }
}

export default new AdminNotificationService();
